import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

type SplashTitleProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  text: string
}

function SplashTitleComponent(props: SplashTitleProps): React.ReactElement<SplashTitleProps> {
  return <plume.styles.heading.S {...props}>{props.text}</plume.styles.heading.S>
}

export const SplashTitle = styled(SplashTitleComponent)`
  background-color: ${plume.COLORS.BLUE_SHADE_2};
  color: ${plume.COLORS.PRIMARY_WHITE};
  display: inline-block;
  font-weight: 700; // HACK: Irregular font manipulation
  line-height: 1.5;
  padding: 0px 10px;
  transform: rotate(-4deg);
`
